import { Component, Host, Prop, h } from '@stencil/core';
import { BlogPostPreview } from '../../../../types/blog';

@Component({
  tag: 'sy-blog-related-post-card',
  styleUrl: 'sy-blog-related-post-card.scss',
  scoped: true,
})
export class SyBlogRelatedPostCard {
  /**
   * The post preview that should be rendered
   */
  @Prop() post?: BlogPostPreview;

  render() {
    return (
      <Host>
        <a href={this.post?.link} target="_self" style={{ height: '100%' }}>
          <div style={{ padding: '1rem' }}>
            <div id="horizontal-container">
              <div id="vertical-container">
                <div id="content">
                  <sy-card-content>
                    <sy-text type="h4" class="category">
                      {this.post?.category}
                    </sy-text>
                    <sy-text type="h5">{this.post?.title}</sy-text>
                  </sy-card-content>
                </div>
                <sy-card-footer>
                  <sy-text type="small">{this.post?.date}</sy-text>
                </sy-card-footer>
              </div>
              <div id="img-container">
                <sy-blog-img
                  slot="img"
                  source={this.post?.img?.src}
                  srcsetWidths={[240]}
                  alt={this.post?.title}
                ></sy-blog-img>
              </div>
            </div>
          </div>
        </a>
      </Host>
    );
  }
}
